import Keycloak from "keycloak-js";
import urls from "@/config/urls"

const auth = new Keycloak({
    url: urls.kcUrl,
    realm: "ufms",
    clientId: "siai-ui"
});

async function init() {
    try {
        const initOptions = {
            enableLogging: false,
            checkLoginIframe: false,
            onLoad: "check-sso",
            pkceMethod: "S256",
            silentCheckSsoFallback: true,
        };
        return auth.init(initOptions)
    } catch (error) {
        console.log(error)
        return false
    }
}

function logout() {
    window.location.href = auth.createLogoutUrl()
}

async function logoutKeycloak() {
    await auth.logout({redirectUri: urls.spaUrl})
}

async function login() {
    if (!auth.authenticated) {
        let redirectUrl = urls.spaUrl + "/oauth-redirect"
        await auth.login({locale: "pt-br", redirectUri: redirectUrl})
    }
}

export const useAuth = () => {
    return {
        auth,
        logout,
        logoutKeycloak,
        login,
        init
    }
}
